import { Button } from "antd";
import React from "react";
import { AiOutlineArrowLeft, AiOutlineLink } from "react-icons/ai";

/**
 *
 * @param {object} props
 * @param {object} props.data module data
 * @param {object} props.subject subject data
 * @returns
 */
export default function ModuleDetails({ data, subject, goBack }) {
  return (
    <div>
      {goBack && (
        <div className="pb-4">
          <Button
            onClick={goBack}
            className="inline-flex items-center gap-2"
            icon={<AiOutlineArrowLeft />}
          >
            Back
          </Button>
        </div>
      )}
      <div
        className="text-xs font-semibold uppercase tracking-wide"
        style={{ color: "#00627B" }}
      >
        {subject?.name}
      </div>
      <div className="pt-2 space-y-6">
        <div className="text-2xl font-bold text-gray-900">{data?.title}</div>

        <div>
          <div className="text-base font-semibold text-gray-900 pb-2">
            Overview
          </div>
          <div className="text-gray-600 leading-relaxed">
            {data?.overview || "No overview provided."}
          </div>
        </div>

        <div>
          <div className="text-base font-semibold text-gray-900 pb-2">
            Resources
          </div>
          {data?.urls?.length ? (
            <div className="space-y-2 w-full flex flex-col">
              {data.urls.map((item) => (
                <a
                  key={item.link}
                  href={item.link}
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center gap-3 px-4 py-3 rounded-lg w-full hover:bg-gray-50 transition-colors"
                  style={{ border: "1px solid #eef1f4" }}
                >
                  <div
                    className="w-8 h-8 rounded-full flex items-center justify-center shrink-0"
                    style={{ background: "#e0f2fe", color: "#00627B" }}
                  >
                    <AiOutlineLink size={16} />
                  </div>
                  <div className="min-w-0">
                    <div className="font-medium text-gray-900 truncate">
                      {item.name}
                    </div>
                    {item.author && (
                      <div className="text-xs text-gray-400">
                        by {item.author}
                      </div>
                    )}
                  </div>
                </a>
              ))}
            </div>
          ) : (
            <div className="text-sm text-gray-500 text-left">
              No Resources available
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
